import { useAuth } from '../contexts/AuthContext'
import { Building2, ChevronDown } from 'lucide-react'
import { useState, useRef, useEffect } from 'react'

const BuildingSwitcher = () => {
  const { isBuildingManager, managedBuildings, selectedBuildingId, setSelectedBuilding } = useAuth()
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  if (!isBuildingManager || managedBuildings.length === 0) return null

  const selectedBuilding = managedBuildings.find(b => b.buildingId === selectedBuildingId)
  const displayName = selectedBuilding?.name || 'Select Building'

  const handleSelect = (buildingId) => {
    setSelectedBuilding(buildingId)
    setIsOpen(false)
    // Reload the current page to refresh data for the new building
    window.location.reload()
  }

  if (managedBuildings.length === 1) {
    return (
      <div className="flex items-center gap-2 px-3 py-1.5 bg-primary-50 border border-primary-200 rounded-lg">
        <Building2 size={16} className="text-primary-600" />
        <span className="text-sm font-medium text-primary-700">{displayName}</span>
      </div>
    )
  }

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-1.5 bg-primary-50 border border-primary-200 rounded-lg hover:bg-primary-100 transition-colors"
      >
        <Building2 size={16} className="text-primary-600" />
        <span className="text-sm font-medium text-primary-700">{displayName}</span>
        <ChevronDown size={14} className={`text-primary-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      {isOpen && (
        <div className="absolute top-full left-0 mt-1 w-64 bg-white rounded-lg shadow-lg border border-slate-200 py-1 z-50">
          {managedBuildings.map((building) => (
            <button
              key={building.buildingId}
              onClick={() => handleSelect(building.buildingId)}
              className={`w-full text-left px-4 py-2 text-sm hover:bg-slate-50 transition-colors ${
                building.buildingId === selectedBuildingId
                  ? 'text-primary-600 bg-primary-50 font-medium'
                  : 'text-slate-700'
              }`}
            >
              {building.name}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default BuildingSwitcher
